import { Injectable, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';

@Injectable({
    providedIn: 'root',
})
export class ProspectStatusServiceService implements OnInit {
    prospectAllStatus = new MatTableDataSource([]);
    backupProspectStauts: any;
    typeOf: any = '';
    prospectStatusForm: FormGroup = this._formBuilder.group({
        name: ['', Validators.required],
        interested_status: ['Positive', Validators.required],
        color: ['#000000', Validators.required],
    });
    updateStatusData: any;
    statusColor: any = '#000000';
    allStatus:any[] = [];
    constructor(private _formBuilder: FormBuilder) {}
    ngOnInit(): void {}
}
